import PropTypes from "prop-types"
import React, { useEffect, useCallback } from "react"

import withRouter from "./Common/withRouter"
import {
  changeLayout,
  changeTopbarTheme,
  changeLayoutWidth,
  changeLayoutMode,
  showRightSidebarAction,
} from "../store/actions"

import Navbar from "../pages/LandingPage/components/Navbar"
import Footer from "./VerticalLayout/Footer"
import Rightbar from "./CommonForBoth/Rightbar"
import AskAIButton from "./AskAIButton/AskAIButton"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

const HeaderOnlyLayout = props => {
  const dispatch = useDispatch()

  const selectLayoutState = state => state.Layout
  const selectLayoutProperties = createSelector(selectLayoutState, layout => ({
    layoutModeType: layout.layoutModeType,
    layoutWidth: layout.layoutWidth,
    topbarTheme: layout.topbarTheme,
    showRightSidebar: layout.showRightSidebar,
  }))

  const {
    layoutModeType,
    layoutWidth,
    topbarTheme,
    showRightSidebar,
  } = useSelector(selectLayoutProperties)

  //hides right sidebar on body click
  const hideRightbar = useCallback(
    event => {
      const rightbar = document.getElementById("right-bar")
      const appRoot = document.querySelector(".ksr-root")
      const safeZone = document.getElementById("layout-click-safe-zone")

      const clickedInsideRightbar = rightbar?.contains(event.target)
      const clickedInsideApp = appRoot?.contains(event.target)
      const clickedInsideSafeZone = safeZone?.contains(event.target)

      if (clickedInsideRightbar || clickedInsideApp || clickedInsideSafeZone) {
        return
      }

      dispatch(showRightSidebarAction(false))
    },
    [dispatch]
  )

  const pathName = props.router.location.pathname

  useEffect(() => {
    //init body click event for toggle rightbar
    document.body.addEventListener("click", hideRightbar)

    // Hide preloader immediately - TopProgressBar handles loading indication
    const preloader = document.getElementById("preloader")
    const status = document.getElementById("status")
    if (preloader) preloader.style.display = "none"
    if (status) status.style.display = "none"

    return () => {
      document.body.removeEventListener("click", hideRightbar)
    }
  }, [hideRightbar, pathName])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    dispatch(changeLayout("vertical"))
  }, [dispatch])

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth))
    }
  }, [layoutWidth, dispatch])

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType))
    }
  }, [layoutModeType, dispatch])

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme))
    }
  }, [topbarTheme, dispatch])

  useEffect(() => {
    // Hide sidebar by removing CSS classes that enable it
    const body = document.body;
    body.classList.remove("sidebar-enable");
    body.classList.add("vertical-sidebar-hidden");
    
    // Add custom CSS to hide sidebar and adjust layout
    const style = document.createElement('style');
    style.textContent = `
      .vertical-sidebar-hidden .vertical-menu {
        display: none !important;
      }
      .vertical-sidebar-hidden #layout-wrapper {
        margin-left: 0 !important;
        padding-left: 0 !important;
      }
      .vertical-sidebar-hidden .main-content {
        margin-left: 0 !important;
        padding-left: 0 !important;
      }
      .vertical-sidebar-hidden .page-content {
        margin-left: 0 !important;
        padding-left: 0 !important;
      }
      /* Allow proper container width control for contact us page - only apply when sidebar is hidden */
      .vertical-sidebar-hidden .container {
        padding-left: 15px !important;
        padding-right: 15px !important;
      }
      /* Force contact form container to be narrower - only when sidebar is hidden */
      .vertical-sidebar-hidden .page-content .container {
        max-width: 1050px !important;
        margin: 0 auto !important;
      }
      /* Responsive container sizing for contact form */
      @media (max-width: 768px) {
        .vertical-sidebar-hidden .page-content .container {
          max-width: 100% !important;
          padding-left: 1rem !important;
          padding-right: 1rem !important;
        }
      }
      @media (min-width: 769px) and (max-width: 992px) {
        .vertical-sidebar-hidden .page-content .container {
          max-width: 720px !important;
        }
      }
      @media (min-width: 993px) and (max-width: 1200px) {
        .vertical-sidebar-hidden .page-content .container {
          max-width: 960px !important;
        }
      }
      @media (min-width: 1201px) {
        .vertical-sidebar-hidden .page-content .container {
          max-width: 1050px !important;
        }
      }
      /* Remove any left margin from content areas - only when sidebar is hidden */
      .vertical-sidebar-hidden .page-content .row,
      .vertical-sidebar-hidden .page-content .col-lg-5,
      .vertical-sidebar-hidden .page-content .col-lg-6 {
        margin-left: 0 !important;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      // Cleanup
      body.classList.remove("vertical-sidebar-hidden");
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <i className="uil-shutter-alt spin-icon"></i>
          </div>
        </div>
      </div>
      <div id="layout-wrapper">
        <Navbar />
        <div className="main-content">
          {props.children}
          <Footer />
        </div>
      </div>

      {/* Floating Ask AI button - available on all pages (mobile and desktop) */}
      <AskAIButton />

      {showRightSidebar ? <Rightbar /> : null}
    </React.Fragment>
  )
}

HeaderOnlyLayout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeLayoutMode: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutModeType: PropTypes.any,
  layoutWidth: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
}

export default withRouter(HeaderOnlyLayout)
